import React from "react";

function toListItem(disclaimer) {
    return <li key={disclaimer.key}>{disclaimer.text}</li>;
}

const Disclaimers = (props) => (
    <div>
        <h3 style={{color: "#28313E", margin: "20px 20px 0 20px", fontSize: "100%"}}>Disclaimers</h3>
        <div style={{margin: "20px 20px 0 20px"}}>
            <ul>{props.disclaimers.map(toListItem)}</ul>
        </div>
    </div>
);

Disclaimers.propTypes = {
    disclaimers: React.PropTypes.arrayOf(React.PropTypes.shape({
        key: React.PropTypes.string.isRequired,
        text: React.PropTypes.string.isRequired
    })).isRequired
};
Disclaimers.defaultProps = {
    disclaimers: []
};

export default Disclaimers;



/** WEBPACK FOOTER **
 ** ./src/main/javascript/disclosure/components/Disclaimers.js
 **/